import { render, staticRenderFns } from "./ShareItem.vue?vue&type=template&id=5e986948&scoped=true"
import script from "./ShareItem.vue?vue&type=script&lang=js"
export * from "./ShareItem.vue?vue&type=script&lang=js"
import style0 from "./ShareItem.vue?vue&type=style&index=0&id=5e986948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e986948",
  null
  
)

export default component.exports